import { CSV_EXPORT_FAILURE, CSV_EXPORT_REQUEST, CSV_EXPORT_SUCCESS, CSV_EXPORT_RESET } from '../actions/csv_export'

export function csvExport(
  state = {
    isFetching: false,
    results: [],
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case CSV_EXPORT_REQUEST:
      return { ...state, isFetching: true, errorMessage: null }
    case CSV_EXPORT_SUCCESS:
      return { ...state, isFetching: false, results: action.response.results, errorMessage: null }
    case CSV_EXPORT_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error }
    case CSV_EXPORT_RESET:
      return { ...state, isFetching: false, errorMessage: null, results: [] }
    default:
      return state
  }
}
